import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: 26px;
`;
Wrapper.displayName = 'Wrapper';

export const Category = styled.div`
  background-color: ${({ theme }) => theme.backgrounds.attributeTag};
  border-radius: 3px;
  border: solid 1px ${({ theme }) => theme.borders.attributeTag};
  color: ${({ theme }) => theme.text.attributeTag};
  font-size: 12px;
  font-weight: 500;
  line-height: 1.92;
  margin: 5px 8px 5px 0;
  padding: 0 8px;
  text-align: center;
  display: flex;
  align-items: center;
  height: 25px;
`;
Category.displayName = 'Category';
